import { Injectable } from '@angular/core';
import { DateRange } from '@angular/material/datepicker';
import { DateTime } from '@lib/date-time';
import { DateAdapter } from '@angular/material/core';
import { FragQueryService } from 'src/injectables/frag-query.service';

@Injectable({ providedIn: 'root' })
export class DateRangeService<D extends Date> {

    public constructor(
        public fragQuery: FragQueryService,
        private _dateAdapter: DateAdapter<D>
    ) { }

    public readonly begin$ = this.fragQuery.begin$;
    public readonly end$ = this.fragQuery.end$;

    public createWeekRange(date: D | null): DateRange<D> {
        if (date) {
            const dayOfWeek = this.getDay(date);
            const start = this._dateAdapter.addCalendarDays(date, -dayOfWeek);
            const end = this._dateAdapter.addCalendarDays(date, 6 - dayOfWeek);
            return new DateRange<D>(start, end);
        }
        return new DateRange<D>(null, null);
    }

    public onStartDateChange(start: D | null): void {
        if (start) {
            this.begin$.next(new DateTime(start));
        }
    }

    public selectionFinished(date: D | null): DateRange<D> {
        const range = this.createWeekRange(date);
        this.onStartDateChange(range.start);
        this.onEndDateChange(range.end);
        return range;
    }

    public onEndDateChange(end: D | null): void {
        if (end) {
            this.end$.next(new DateTime(end));
        }
    }

    public getDay(date: Date): number {
        return date.getDay();
    }
}
